 

import type { RouteObject } from 'react-router';
import { lazyRoute } from '../utils/lazyRoute';

const salesRoutes: RouteObject[] = [
  {
    path: 'SAL/*',
    children: [
      { path: 'HomePage', lazy: lazyRoute(() => import('../../pages/Sales/SalesHome/SalesHome')) },

      // Customers
      { path: 'Customers', lazy: lazyRoute(() => import('../../pages/Sales/SalesSettings/Customers/Index')) },
      {
        path: 'Customers/AddCustomers',
        lazy: lazyRoute(() => import('../../pages/Sales/SalesSettings/Customers/Add'))
      },
      // {
      //   path: 'Customers/:Id/UpdateCustomers',
      //   lazy: lazyRoute(() => import('../../pages/Sales/SalesSettings/Customers/Update'))
      // },
      {
        path: 'Customers/:id/BranchesCustomer',
        lazy: lazyRoute(() => import('../../pages/Sales/SalesSettings/Customers/Branches/Index'))
      },
      {
        path: 'Customers/:peopleId/PeopleLocations',
        lazy: lazyRoute(() => import('../../pages/Sales/SalesSettings/Customers/CustomersLocations/CustomersLocations'))
      },

      // PriceList
      { path: 'PriceList', lazy: lazyRoute(() => import('../../pages/Sales/SalesSettings/PriceList/Index')) },
      {
        path: 'PriceList/:id/DetailsPriceList',
        lazy: lazyRoute(() => import('../../pages/Sales/SalesSettings/PriceList/Paged/DetailsPriceList'))
      },

      // Vouchers  
      // { path: 'Vouchers', lazy: lazyRoute(() => import('../../pages/Sales/Vouchers/Index')) },
      // { path: 'Vouchers/AddVouchers', lazy: lazyRoute(() => import('../../pages/Sales/Vouchers/AddVoucher')) },

      { path: 'Vouchers', lazy: lazyRoute(() => import('../../pages/POS/Vouchers/Index')) },

      { path: 'Vouchers/AddUpdateVouchers', lazy: lazyRoute(() => import('../../pages/POS/Vouchers/VoucherForm')) },
     
      { path: 'Vouchers/AddNewVouchers', lazy: lazyRoute(() => import('../../pages/POS/Vouchers/AddNewVoucher')) },
      // {
      //   path: 'Vouchers/:voucherId/AddUpdateVouchers',
      //   lazy: lazyRoute(() => import('../../pages/POS/Vouchers/VoucherForm'))
      // }
      {
        path: 'Vouchers/:voucherId/AddUpdateVouchers',
        lazy: lazyRoute(() => import('../../pages/POS/Vouchers/QtyListItemType/VoucherEdit'))
      }

      // Vouchers2
      // { path: 'Vouchers2', lazy: lazyRoute(() => import('../../pages/Sales/Vouchers2/Index')) },
      // { path: 'Vouchers2/:voucherTypeId/VoucherType', lazy: lazyRoute(() => import('../../pages/Sales/Vouchers2/VoucherType')) },
      // {
      //   path: 'Vouchers2/:voucherTypeId/VoucherType/:voucherId?/BuyXgetY',
      //   lazy: lazyRoute(() => import('../../pages/Sales/Vouchers2/BuyXgetY/Add'))
      // }
    ]
  },

  {
    path: 'SAL/*',
    children: [
      // Contracts
      { path: 'Contracts', lazy: lazyRoute(() => import('../../pages/Sales/Transactions/Contracts/index/Contracts')) },
      {
        path: 'Contracts/AddSalesContracts',
        lazy: lazyRoute(() => import('../../pages/Sales/Transactions/Contracts/Add/AddContracts'))
      },

      // SellOrder
      { path: 'SellOrder', lazy: lazyRoute(() => import('../../pages/Sales/Transactions/SellOrder/Index')) },
      {
        path: 'SellOrder/AddSellOrder/:id?',
        lazy: lazyRoute(() => import('../../pages/Sales/Transactions/SellOrder/Add'))
      },
      {
        path: 'SellOrder/:id/UpdateSellOrder',
        lazy: lazyRoute(() => import('../../pages/Sales/Transactions/SellOrder/Update'))
      },

      // Quotation
      { path: 'Quotation', lazy: lazyRoute(() => import('../../pages/Sales/Transactions/Quotation/Index')) },
      { path: 'Quotation/AddQuotation', lazy: lazyRoute(() => import('../../pages/Sales/Transactions/Quotation/Add')) },
      {
        path: 'Quotation/:id/UpdateQuotation',
        lazy: lazyRoute(() => import('../../pages/Sales/Transactions/Quotation/Update'))
      },

      // Sales Return
      { path: 'SalesReturn', lazy: lazyRoute(() => import('../../pages/Sales/Transactions/SalesReturn/Index')) },
      {
        path: 'SalesReturn/:InvoiceId/AddSalesReturn',
        lazy: lazyRoute(() => import('../../pages/Sales/Transactions/SalesReturn/SalesReturn'))
      },

      // Sales Types + Form Columns
      { path: 'SalesTypes', lazy: lazyRoute(() => import('../../pages/Sales/SalesTypes/Index')) },
      {
        path: 'SalesTypes/:id/FormColumns/:type?',
        lazy: lazyRoute(() => import('../../pages/NTX/FlexValue/FormColumn/AddFormColumn'))
      }
    ]
  },

  {
    path: 'SAL/*',
    children: [
      // Dashboards
      { path: 'SalesDashboards', lazy: lazyRoute(() => import('../../pages/Sales/SalesDashboards/SalesDashboards')) },
      {
        path: 'SalesDashboards/:dashboardId/BuilderDashboard',
        lazy: lazyRoute(() => import('../../pages/NTX/DashboardManagament/BuilderDashboard/BuilderDashboard'))
      },

      // Reports
      { path: 'SalesReports', lazy: lazyRoute(() => import('../../pages/Sales/SalesReports/SalesReports')) },
      {
        path: 'SalesReports/:ReportId/ReportsBuilder',
        lazy: lazyRoute(
          () => import('../../pages/NTX/Reports/ReportsAllByModule/Reports/ReportsBuilder/ReportsBuilder')
        )
      }
    ]
  }
];

export default salesRoutes;
